function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function Svg187FalklandIslands(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#0052B4"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "413.681,293.101 413.681,300.522 354.318,300.522 354.318,293.101 332.058,293.101   332.058,322.783 346.899,322.783 346.899,330.203 421.101,330.203 421.101,322.783 435.942,322.783 435.942,293.101 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#338AF3"
    },
    d: "M332.058,181.797v81.623c0,39.759,51.942,51.942,51.942,51.942s51.942-12.182,51.942-51.942v-81.623  L332.058,181.797L332.058,181.797z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3F3F3"
    },
    d: "M383.997,242.68c-12.985,0-12.985,11.873-25.97,11.873s-12.985-11.873-25.97-11.873v20.777   c12.985,0,12.985,11.873,25.97,11.873s12.985-11.873,25.97-11.873c12.986,0,12.986,11.873,25.973,11.873   c12.986,0,12.986-11.873,25.973-11.873V242.68c-12.986,0-12.986,11.873-25.973,11.873   C396.984,254.552,396.984,242.68,383.997,242.68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3F3F3"
    },
    d: "M383.997,201.09c-12.985,0-12.985,11.873-25.97,11.873s-12.985-11.873-25.97-11.873v20.777   c12.985,0,12.985,11.873,25.97,11.873s12.985-11.873,25.97-11.873c12.986,0,12.986,11.873,25.973,11.873   c12.986,0,12.986-11.873,25.973-11.873V201.09c-12.986,0-12.986,11.873-25.973,11.873   C396.984,212.962,396.984,201.09,383.997,201.09z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "256,0 256,48.896 215.853,89.043 256,89.043 256,166.957 203.464,166.957 256,219.492   256,256 232.281,256 166.957,190.664 166.957,256 89.043,256 89.043,178.276 11.331,256 0,256 0,207.104 40.147,166.957 0,166.957   0,89.043 52.536,89.043 0,36.508 0,0 23.719,0 89.043,65.336 89.043,0 166.957,0 166.957,77.724 244.669,0 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "0,152.001 103.999,152.001 103.999,256 151.999,256 151.999,152.001 256,152.001   256,104.001 151.999,104.001 151.999,0 103.999,0 103.999,104.001 0,104.001 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "166.957,166.957 256,256 256,230.82 192.137,166.957 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "166.957,166.957 256,256 256,230.82 192.137,166.957 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "166.957,166.957 256,256 256,230.82 192.137,166.957  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "63.862,166.959 0,230.821 0,256 0,256 89.041,166.959  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "89.043,89.043 0,0 0,25.18 63.863,89.043 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "89.043,89.043 0,0 0,25.18 63.863,89.043 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "89.043,89.043 0,0 0,25.18 63.863,89.043  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "192.138,89.041 256,25.179 256,0 256,0 166.959,89.041  "
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg187FalklandIslands);
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };